__turbopack_context__.v({
  "buttonContainer": "zkLC3a_buttonContainer",
  "buttonPill": "zkLC3a_buttonPill",
});
